module.exports = __webpack_public_path__ + "img/a4.6308b51b.png";